export { default } from './Image';